import React from 'react';
import { AppMode } from '@/app/types/cad';
import { useLanguage } from '@/app/contexts/LanguageContext';

interface ModeSelectorProps {
  currentMode: AppMode;
  onModeChange: (mode: AppMode) => void;
}

export function ModeSelector({ currentMode, onModeChange }: ModeSelectorProps) {
  const { t } = useLanguage();

  return (
    <div 
      className="flex items-center gap-1 px-4 py-2 border-b"
      style={{
        backgroundColor: 'var(--md-surface)',
        borderColor: 'var(--md-outline-variant)',
      }}
    >
      <button
        onClick={() => onModeChange('iso-block')}
        className={`px-4 py-2 rounded-t font-medium transition-all ${
          currentMode === 'iso-block'
            ? 'text-white shadow-sm'
            : 'hover:bg-opacity-10'
        }`}
        style={{
          backgroundColor: currentMode === 'iso-block' 
            ? 'var(--md-primary)' 
            : 'transparent',
          color: currentMode === 'iso-block'
            ? 'var(--md-on-primary)'
            : 'var(--md-on-surface-variant)',
        }}
      >
        {t('app.modes.isoBlock').toUpperCase()}
      </button>
      <button
        onClick={() => onModeChange('block-system')}
        className={`px-4 py-2 rounded-t font-medium transition-all ${
          currentMode === 'block-system'
            ? 'text-white shadow-sm'
            : 'hover:bg-opacity-10'
        }`}
        style={{
          backgroundColor: currentMode === 'block-system' 
            ? 'var(--md-primary)' 
            : 'transparent',
          color: currentMode === 'block-system'
            ? 'var(--md-on-primary)'
            : 'var(--md-on-surface-variant)',
        }}
      >
        {t('app.modes.blockSystem').toUpperCase()}
      </button>
      <button
        onClick={() => onModeChange('system-table')}
        className={`px-4 py-2 rounded-t font-medium transition-all ${
          currentMode === 'system-table'
            ? 'text-white shadow-sm'
            : 'hover:bg-opacity-10'
        }`}
        style={{
          backgroundColor: currentMode === 'system-table' 
            ? 'var(--md-primary)' 
            : 'transparent',
          color: currentMode === 'system-table'
            ? 'var(--md-on-primary)'
            : 'var(--md-on-surface-variant)',
        }}
      >
        {t('app.modes.systemTable').toUpperCase()}
      </button>
    </div>
  );
}